var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1141 17.9999L22.4807 5.63327L20.8182 3.99993L10.0849 14.7041L5.15573 9.74577L3.49323 11.4083L10.1141 17.9999ZM10.1141 21.2958L0.226562 11.4083L5.15573 6.44993L10.1141 11.4083L20.7891 0.704102L25.8057 5.6041L10.1141 21.2958Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoneOutline);
export default __webpack_public_path__ + "static/media/icon_done_outline.45984337bdd3de9d8bc13e9d8018f133.svg";
export { ForwardRef as ReactComponent };